// eslint-disable-next-line import/no-extraneous-dependencies
import { usePostHog } from 'posthog-js/react';
import { useEffect } from 'react';

import { User } from '../services/types/user-types';

export const usePostHogIdentify = (user: User | null | undefined) => {
  const posthog = usePostHog();

  useEffect(() => {
    if (user?.id && user?.email) {
      if (import.meta.env.MODE === 'development') {
        // eslint-disable-next-line no-console
        console.log('[PostHog] identify', {
          id: user.id,
          email: user.email,
          first_name: user.first_name,
          last_name: user.last_name,
          username: user.username,
        });
      }

      posthog.identify(user.id, {
        email: user.email,
        id: user.id,
        first_name: user.first_name,
        last_name: user.last_name,
        username: user.username,
      });
    }
  }, [
    user?.id,
    user?.email,
    user?.first_name,
    user?.last_name,
    user?.username,
    posthog,
  ]);
};
